<template>
  <el-drawer
    :title="$l('INDEX.advanced_search') || '高级搜索'"
    :visible="visible"
    :size="600"
    direction="rtl"
    :wrapper-closable="false"
    @close="close"
  >
    <div class="drawer-main">
      <el-form ref="form" :model="form" size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_custName') || '客户名称'">
              <el-input
                v-model.trim="form.custName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_region') || '所在国家'">
              <dict-select
                v-model="form.listRegionCode"
                url="/master/common/dict/biz"
                :body="{ dictType: 'region' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_customerBizType') || '客户类型'"
            >
              <dict-select
                v-model="form.customerBizType"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'customerBizType' }"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_customerType') || '客户性质'">
              <dict-select
                v-model="form.customerType"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                url="/digitalCenter/common/dict/biz"
                :body="{ dictType: 'customerType' }"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_riskLevel') || '风险等级'">
              <dict-select
                v-model="form.riskLevel"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'riskLevel' }"
                clearable
                filterable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
      </el-button>
      <el-button size="small" type="warning" @click="reset()">
        {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
      </el-button>
      <el-button size="small" type="primary" @click="advquery()">
        {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
      </el-button>
    </div>
  </el-drawer>
</template>

<script>
const initForm = {}
export default {
  props: { visible: { type: Boolean, default: false } },
  data() {
    return {
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.form)
    },
    advquery() {
      this.query()
      this.close()
    },
    reset() {
      this.form = { ...initForm }
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
